/**
 * PopupListContainer
 * --
 */
import React from 'react';
import PopupListPresenter from './PopupListPresenter';

const PopupListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <PopupListPresenter />
    </>
  );
};

export default PopupListContainer;
